var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<hr/>\n<div class=\"row\">\n<div class=\"col-md-10\">\n<h4>{{title}}</h4>\n</div>\n<div class=\"col-md-2\">\n<h4></h4>\n<button ng-click=\"downloadCsv()\" class=\"btn btn-light text-nowrap btn-sm\">\n<i class=\"fa fa-file-text-o\" aria-hidden=\"true\"></i>\nCSV\n</button>\n</div>\n</div>\n";
var id1="app/_directives/tso-details-header.directive.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;